/**
 *
 * PrivacyLink
 *
 */

import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import messages from './messages';

function PrivacyLink() {
  return (
    <a href="#privacy">
      <FormattedHTMLMessage {...messages.privacy} />
    </a>
  );
}

export default PrivacyLink;
